module.exports = __webpack_public_path__ + "static/media/A.49ff53bb.PNG";